// Loader.js
import React, { useState, useEffect } from 'react';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

const ProgressLoader = () => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercentage(prev => (prev < 100 ? prev + 1 : 100));
    }, 50); // Adjust the speed here by changing the interval duration

    return () => clearInterval(interval); // Cleanup on unmount
  }, []);

  return (
    <div style={{ width: 100, height: 100 }}>
      <CircularProgressbar
        value={percentage}
        text={`${percentage}%`}
        styles={buildStyles({
          pathColor: '#c0272d',             // Set the progress path color to red
          textColor: '#c0272d',             // Set the text color to red
          trailColor: '#d6d6d6',        // Customize the trail color
          backgroundColor: '#3e98c7',   // Optional: background color
        })}
      />
    </div>
  );
};

export default ProgressLoader;
